import { render, staticRenderFns } from "./host-set-areaMan.vue?vue&type=template&id=42806bd9&scoped=true&"
import script from "./host-set-areaMan.vue?vue&type=script&lang=js&"
export * from "./host-set-areaMan.vue?vue&type=script&lang=js&"
import style0 from "./host-set-areaMan.vue?vue&type=style&index=0&id=42806bd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42806bd9",
  null
  
)

export default component.exports